import Vue from "vue";

export const ACTIONS = {
  // UI
  SNACKBAR: "show-snackbar",
  TRIGGER_SCROLL: "triggerScroll",
  TRIGGER_INFINITE_SCROLL: "trigger-infinite-scroll",
  SCROLL_TO_ELEMENT: "scroll-to-element",
  CLOSE: "close",
  SPINNER_ON: "spinner-on",
  SPINNER_OFF: "spinner-off",
  FACETS_UPDATE: "facets-update",
  SHOW_SHARE_UNLOCK_CONTRIBUTION: "show-share-unlock-contribution",
  SHOW_SHARE_LINK_DROPDOWN: "show-share-link-dropdown",
  HANDLE_TABLE_SORT: "handle-table-sort",
  SELECTED_TAB: "selected-tab",

  //SETTINGS
  ENABLE_PUSH: "enable-push",
  DISABLE_PUSH: "disable-push",
  PUSH_STATUS: "push-status",

  //CONTEST DRAFT
  HANDLE_DRAFT_PLAYER: "handle-draft-player",
  FILTER_BY_POSITION: "filter-by-position",
  UPDATE_PLAYERS: "update-players",
  HANDLE_SAVE_CLICK: "handle-save-click",
  SAVE_DRAFT: "save-draft",
  HANDLE_EDIT_MODE: "handle-edit-mode",

  // INPUTS
  UPDATE_VALUE: "updatedValue",
  NEW_VALUE: "new-value",

  // MODALS
  SHOW_ONRAMP: "show-onramp",
  SHOW_ASTROPAY: "show-astropay",
  SHOW_TRADE_MODAL: "show-trade-modal",
  SHOW_UNLOCK_MODAL: "show-unlock-modal",
  // SHOW_TRADE_MODAL: "show-card-trade-modal",
  CLOSE_TRADE_MODAL: "close-card-trade-modal",
  SELECTED_ITEM: "selected-tiem",
  SHOW_PLAYER_STATS_MODAL: "show-player-stats-modal",
  SHOW_CONTEST_TEAM_PITCH_MODAL: "show-contest-team-pitch-modal",
  CLOSE_DEPOSIT_MODAL: "close-deposit-modal",
  OPEN_DEPOSIT_MODAL: "open-deposit-modal",

  // CURRENCY
  CURRENCY_SELECT: "currency-select",
  CURRENCIES_RATE_UPDATE: "currencies-rate-update",
  CURRENCY_UPDATE: "currency-update",

  // TRANSACTIONS
  ETH_WALLET_TX: "eth-transaction-ok",
  ETH_UPDATE_ACCOUNTS: "eth-update-accounts",
  DEPOSIT_TX: "deposit-tx",
  FAILED_DEPOSIT: "failed-deposit",
  WITHDRAW_TX: "withdraw-tx",
  CHECK_PENDING_UNLOCK_TX: "check-pending-unlock-tx",
  TRANSACTION_OK: "transaction-ok",
  PORTFOLIO_UPDATE: "portfolio-update",
  COMPLETED_DEPOSIT: "completed-deposit",
  TRADE_STOCK: "trade-stock",
  UNLOCK: "unlock",
  CLAIM_PRIZES: "claim-prizes",

  // ADMIN SEND FUNDS
  SEND_FUNDS: "send-funds",
  SEND_FUNDS_FAILED: "send-funds-failed",

  // WALLETS
  WALLET_UNLOCKED: "wallet-unlocked",
  WALLET_CONNECTED: "connected",
  WALLET_CONNECTING_EVT: "wallet-connecting-evt",
  WALLET_CANCELED_EVT: "wallet-canceled-evt",
  WALLET_DISCONNECT: "wallet-disconnect-evt",
  SELECTED_WALLET: "selected-wallet",

  // FAVORITE CARDS
  UPDATED_FAVORITE_CARDS: "updated-favorite-cards",

  // PUSHER EVENT
  PUSHER_CONTRIBUTION_UPDATE: "pusher-contribution-update",
  PUSHER_CREATE_CONTEST: "pusher-create-contest",
  PUSHER_EDIT_CONTEST: "pusher-edit-contest",
  PUSHER_CREATE_ENTRY: "pusher-create-entry",
  PUSHER_LIVESCORES: "pusher-livescores",

  // CONTESTS
  CONTEST_EDIT: "contest-edit",
  CONTEST_DELETE: "contest-delete",

  // CONTEST ENTRY
  SELECTED_ENTRY: "selected-entry",
};

const EventBus = new Vue();

export default EventBus;
